<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCIcons :icons="icons" />
  </div>
</template>

<script>
import FCIcons from "@/components/patterns/FCIcons";
export default {
  components: {
    FCIcons
  },
  mounted() {
    const ref = this.$store.state.menu.westEndStadium.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.westEndStadium.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.westEndStadium.nav;
    this.onScroll();
  },
  data() {
    return {
      icons: [
        [
          {
            icon: "facts-capacity.svg"
          },
          {
            icon: "facts-suites.svg"
          },
          {
            icon: "facts-grassfield.svg"
          },
          {
            icon: "facts-motionlighting.svg"
          },
          {
            icon: "facts-closestseat.svg"
          },
          {
            icon: "facts-canopy.svg"
          },
          {
            icon: "facts-parking.svg"
          }
        ],
        [
          {
            icon: "facts-videoboard.svg"
          },
          {
            icon: "facts-foodandbeverage.svg"
          },
          {
            icon: "facts-thebailey.svg"
          },
          {
            icon: "facts-ordering.svg"
          },
          {
            icon: "facts-teamstore.svg"
          },
          {
            icon: "facts-wifi.svg"
          }
        ]
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-stadiumfacts.jpg");
  background-size: cover;
  background-position: center;
}
</style>